import React from 'react'
import RegistrationLayout from '../../_global/RegistrationLayout'
import CreateAccount from '../../pages/Registration/CreateAccount'

interface RegistrationComponentProps {
  history: any
  queryParamsWithSource?: boolean
  setIsFirm: (isFirm: boolean) => void
}

const ByobOnboarding = ({ history, queryParamsWithSource, setIsFirm }: RegistrationComponentProps) => {
  return (
    <RegistrationLayout isByob={true}>
      <CreateAccount history={history} isFurloughReferral={!!queryParamsWithSource} setIsFirm={setIsFirm} isByob={true} />
    </RegistrationLayout>
  )
}

export default ByobOnboarding
